"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DayOneSMAMetricNames = exports.initialiseDayOne = exports.getDayOneDependency = void 0;
const luxon_1 = require("luxon");
const DayOneIngressWidgetTypes_1 = require("../components/DayOneIngressWidget/DayOneIngressWidgetTypes");
Object.defineProperty(exports, "DayOneSMAMetricNames", { enumerable: true, get: function () { return DayOneIngressWidgetTypes_1.DayOneSMAMetricNames; } });
const getDependenciesSma_1 = __importDefault(require("./getDependenciesSma"));
let dayOneDependency;
const initialiseDayOne = (props) => {
    const { i18n } = props;
    luxon_1.Settings.defaultLocale = i18n.language;
    if (!dayOneDependency) {
        dayOneDependency = (0, getDependenciesSma_1.default)(props);
    }
};
exports.initialiseDayOne = initialiseDayOne;
const getDayOneDependency = () => dayOneDependency;
exports.getDayOneDependency = getDayOneDependency;
//# sourceMappingURL=initialiseDayOne.js.map